import { useState } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export function usePdfDownload() {
  const [isGenerating, setIsGenerating] = useState(false);

  const downloadPdf = async () => {
    const printEl = document.getElementById("print-content-root");
    if (!printEl) {
      alert("印刷コンテンツが見つかりません。");
      return;
    }

    setIsGenerating(true);

    try {
      const prevDisplay = printEl.style.display;
      const prevPosition = printEl.style.position;
      const prevLeft = printEl.style.left;
      const prevWidth = printEl.style.width;

      printEl.style.display = "block";
      printEl.style.position = "absolute";
      printEl.style.left = "-9999px";
      printEl.style.width = "794px";

      await new Promise((resolve) => setTimeout(resolve, 300));

      const canvas = await html2canvas(printEl, {
        scale: 2,
        backgroundColor: "#ffffff",
      });

      printEl.style.display = prevDisplay;
      printEl.style.position = prevPosition;
      printEl.style.left = prevLeft;
      printEl.style.width = prevWidth;

      const imgData = canvas.toDataURL("image/jpeg", 0.95);
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
      });

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();

      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;

      const imgWidthMm = pdfWidth;
      const imgHeightMm = (canvasHeight / canvasWidth) * pdfWidth;

      let yOffset = 0;
      let pageCount = 0;

      while (yOffset < imgHeightMm) {
        if (pageCount > 0) pdf.addPage();

        const srcYPx = (yOffset / imgHeightMm) * canvasHeight;
        const srcHeightPx = (pdfHeight / imgHeightMm) * canvasHeight;

        const pageCanvas = document.createElement("canvas");
        pageCanvas.width = canvasWidth;
        pageCanvas.height = Math.min(srcHeightPx, canvasHeight - srcYPx);
        const ctx = pageCanvas.getContext("2d");
        if (ctx) {
          ctx.drawImage(
            canvas,
            0,
            srcYPx,
            canvasWidth,
            pageCanvas.height,
            0,
            0,
            canvasWidth,
            pageCanvas.height
          );
        }

        const pageImgData = pageCanvas.toDataURL("image/jpeg", 0.95);
        const pageImgHeightMm = (pageCanvas.height / canvasWidth) * pdfWidth;

        pdf.addImage(pageImgData, "JPEG", 0, 0, imgWidthMm, pageImgHeightMm);

        yOffset += pdfHeight;
        pageCount++;
      }

      pdf.save("住宅大全2026.pdf");
    } catch (err) {
      console.error("PDF生成エラー:", err);
      alert("PDF生成中にエラーが発生しました。");
    } finally {
      setIsGenerating(false);
    }
  };

  return { isGenerating, downloadPdf };
}
